import React, { useState, useEffect } from 'react';
import { Button, Table, Container, Alert, Collapse, Spinner, Modal, Form } from 'react-bootstrap';
import api from '../../../redux/actions/configApi'; // Assumindo que a API está configurada nesse arquivo
import Loader from '../../../components/loading';
import PaginationComponent from '../../../components/paginacao';
import '../../../style/proposta.css';

const Proposta = () => {
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pedidos, setPedidos] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const [selectedVenda, setSelectedVenda] = useState(null);
    //Paginação
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotalPage] = useState(1);
   
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };
    const STATUS_MAP = {
        1: "Pendente",
        2: "Aprovado",
        3: "Cancelado",
    };
    const getStatusLabel = (value) => STATUS_MAP[value] || "Desconhecido";
    // Função para buscar as propostas da API
    const fetchPedidosUser = async (page = 1) => {
        try {
            setLoading(true);
            const response = await api.get(`pedidos-user?page=${page}`);
            const { orders } = response.data;

            // Salva as propostas e as informações de paginação no estado
            setPedidos(orders);
            //Paginacao
            const itemsPerPage = 10
            const totalPages = Math.ceil(orders.total / itemsPerPage);
            setTotalPage(totalPages)
            setCurrentPage(orders.current_page)
            setLoading(false);
        } catch (error) {
            console.log(error, 'error')
            setError('Erro ao carregar as propostas.');
            setLoading(false);
        }
    };

    // UseEffect para buscar as propostas ao montar o componente
    useEffect(() => {
        fetchPedidosUser();
    }, []);

   /* const handlePageChange = (page) => {
       fetchPedidosUser (page);
    };*/

    // Função para exibir detalhes da proposta selecionada
    const handleViewDetails = (venda) => {
        setSelectedVenda(venda);
        setShowModal(true); // Abre o modal
    };
  

    return (
        <Container>

            <h2 className='text-center mb-4'>Pedidos</h2>
            {success && (
                <Alert className="text-center " variant="success">
                    {success}
                    <Button className="m-3" variant="close" onClick={() => setSuccess(null)}></Button>
                </Alert>
            )}
            {error && (
                <Alert className="text-center " variant="danger">
                    {error}
                    <Button className="m-3" variant="close" onClick={() => setError(null)}></Button>
                </Alert>
            )}
            <div className='d-flex justify-content-center'>
                <PaginationComponent
                    currentPage={currentPage}
                    lastPage={total}
                    onPageChange={handlePageChange}
                />
            </div>
            <div className={`loading ${loading ? 'loading-active' : ''}`}>
                <Loader loading={loading} />
                <Table striped bordered hover responsive className='text-center mt-4' style={{ fontSize: '0.8em' }}>
                    <thead>
                        <tr>
                            <th>N° pedido</th>
                            <th>Cliente</th>
                            <th>Data do Pedido</th>
                            <th>Status</th>
                            <th>Forma de Pagamento</th>
                            <th>Total</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pedidos?.data?.length > 0 ? (
                            pedidos?.data?.map((venda, index) => (
                                <tr key={venda.id}>
                                    <td>{venda.order_code}</td>
                                    <td>{venda.user?.name || 'Cliente não identificado'}</td>
                                    <td>{new Date(venda.created_at).toLocaleDateString()}</td>
                                    <td>{getStatusLabel(venda.payment?.status)}</td>
                                    <td>{venda.payment?.payment_method || 'N/A'}</td>
                                    <td>{!isNaN(Number(venda.total_price)) ? Number(venda.total_price).toFixed(2) : 'Valor inválido'}</td>
                                    <td>
                                        <Button
                                            variant="info"
                                            size="sm"
                                            className="me-2"
                                            onClick={() => handleViewDetails(venda)}
                                        >
                                            Visualizar
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">
                                    Nenhum pedido encontrado.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
            <Modal className="modal-custom" show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes do Pedido</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedVenda && (
                        <div>
                            <p><strong>Cliente:</strong> {selectedVenda.user?.name}</p>
                            {/*<p><strong>Endereço:</strong> {selectedVenda.address?.address_line}</p>*/}
                            <p><strong>Status: </strong>{getStatusLabel(selectedVenda.payment?.status)} </p>
                            <p><strong>Forma de Pagamento:</strong> {selectedVenda.payment?.payment_method}</p>
                            <p><strong>Total:</strong> R$ {!isNaN(Number(selectedVenda.total_price)) ? Number(selectedVenda.total_price).toFixed(2) : 'valor inválido'}</p>
                            <h5>Produtos:</h5>
                            <ul>
                                {selectedVenda?.order_items?.map((item) => (
                                    <li key={item.id}>
                                        {item.product.name} - {item.quantity} x R$ {Number(item.unit_price).toFixed(2)} = R$ {Number(item.total_price).toFixed(2)}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

        </Container >
    );
};

export default Proposta;
